import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VueScrollTo from 'vue-scrollto';
export default {
  name: 'FibInput',
  props: {
    autocapitalize: {
      type: String,
      default: 'none'
    },
    autocomplete: {
      type: String,
      default: 'on'
    },
    autocorrect: {
      type: String,
      default: 'on'
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    autogrow: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: undefined
    },
    lazyRules: {
      type: Boolean,
      default: true
    },
    mask: {
      type: String,
      default: ''
    },
    maxLength: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    right: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 1 // Rows is required for minHeight calculation, so assume 1 if not specified

    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    spellcheck: {
      type: String,
      default: 'true'
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: [String, Number],
      default: ''
    },
    fillMask: {
      type: Boolean,
      default: false
    },
    inputClass: {
      type: [String, Object],
      default: ''
    },
    outlined: {
      type: Boolean,
      default: true
    },
    borderless: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      autoScrollTimeout: null
    };
  },
  computed: {
    minHeight: function minHeight() {
      // Calculate minimum textarea height based on number of rows requested
      var height;

      if (this.rows === 1) {
        height = 26;
      } else if (this.rows === 2) {
        height = 37;
      } else {
        height = 37 + (this.rows - 2) * 18;
      }

      return {
        minHeight: "".concat(height, "px")
      };
    }
  },
  methods: {
    handleFocus: function handleFocus(evt) {
      this.$emit('focus'); // on mobile devices we want to scroll the input into view (as the virtual keyboard will be open)

      if (!this.$q.platform.is.mobile && !this.$q.platform.is.nativeMobile) {
        return;
      }

      var target = evt.target;

      if (!target) {
        return;
      } // scroll the focused element within view. We use a timeout to give the keyboard time to
      // open so that it's not scrolled into an area that's about to be removed.


      clearTimeout(this.autoScrollTimeout);
      this.autoScrollTimeout = setTimeout(function () {
        VueScrollTo.scrollTo(target, 500, {
          offset: -40,
          force: true
        });
      }, 700);
    },
    resetValidation: function resetValidation() {
      this.$refs.self.resetValidation();
    },
    validate: function validate() {
      return this.$refs.self.validate();
    }
  }
};